/* eslint-disable max-len */
// import _ from 'lodash';
import itemManagementService from "src/services/itemManagementService";
// import skuService from 'src/services/skuService';

export const GET_ITEMS_REQUEST = "@item/get-items-request";
export const GET_ITEMS_SUCCESS = "@item/get-items-success";
export const GET_ITEMS_FAILURE = "@item/get-items-failure";

export const GET_ITEMS_BY_BARCODE_REQUEST = "@item/get-items-by-barcode-request";
export const GET_ITEMS_BY_BARCODE_SUCCESS = "@item/get-items-by-barcode-success";
export const GET_ITEMS_BY_BARCODE_FAILURE = "@item/get-items-by-barcode-failure";

export const ADD_ITEM_REQUEST = "@item/add-item-request";
export const ADD_ITEM_SUCCESS = "@item/add-item-success";
export const ADD_ITEM_FAILURE = "@item/add-item-failure";

export const UPDATE_ITEM_REQUEST = "@item/update-item-request";
export const UPDATE_ITEM_SUCCESS = "@item/update-item-success";
export const UPDATE_ITEM_FAILURE = "@item/update-item-failure";

export const GET_ITEM_REQUEST = "@item/get-item-request";
export const GET_ITEM_SUCCESS = "@item/get-item-success";
export const GET_ITEM_FAILURE = "@item/get-item-failure";

export const DELETE_ITEM_REQUEST = "@item/delete-item-request";
export const DELETE_ITEM_SUCCESS = "@item/delete-item-success";
export const DELETE_ITEM_FAILURE = "@item/delete-item-failure";

export const CLEAR_ITEMS = "@item/clear-items";

export function getListItems(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ITEMS_REQUEST});
      let response = await itemManagementService.getItems(params);
      response = response.data;
      // const itemsResponse = await itemManagementService.getItems(params);
      // const skuResponse = await skuService.getListSkus();

      // const response = _.map(itemsResponse.data, (item) => _.extend(item, { skuItems: [_.find(skuResponse, { item_id: item.id })] }));
      dispatch({
        type: GET_ITEMS_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ITEMS_FAILURE});
      throw error;
    }
  };
}

export function clearListItems() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_ITEMS
    });
  };
}

export function addItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ITEM_REQUEST});
      const response = await itemManagementService.createItem(data);
      dispatch({
        type: ADD_ITEM_SUCCESS,
        payload: {
          response
        }
      });
      return response;
    } catch (error) {
      dispatch({type: ADD_ITEM_FAILURE});
      throw error;
    }
  };
}

export function updateItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_ITEM_REQUEST});
      const response = await itemManagementService.updateItem(data);
      dispatch({
        type: UPDATE_ITEM_SUCCESS,
        payload: {
          response
        }
      });
      return response;
    } catch (error) {
      dispatch({type: UPDATE_ITEM_FAILURE});
      throw error;
    }
  };
}

export function getItem(itemId) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ITEM_REQUEST});
      const response = await itemManagementService.getItem(itemId);
      dispatch({
        type: GET_ITEM_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ITEM_FAILURE});
      throw error;
    }
  };
}

export function getListItemsByBarcode(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ITEMS_BY_BARCODE_REQUEST});
      let response = await itemManagementService.getItemsByBarcode(params);
      response = response.data;
      // const itemsResponse = await itemManagementService.getItems(params);
      // const skuResponse = await skuService.getListSkus();

      // const response = _.map(itemsResponse.data, (item) => _.extend(item, { skuItems: [_.find(skuResponse, { item_id: item.id })] }));
      dispatch({
        type: GET_ITEMS_BY_BARCODE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ITEMS_BY_BARCODE_FAILURE});
      throw error;
    }
  };
}
